<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/SeatingStatus/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'seatingStatus'
    }
  },

  async created () {
    await this.$store.dispatch(`${this.modelName}/getMe`)
    await this.$store.dispatch(`${this.modelName}/get`)
    if (!this.$store.getters[`${this.modelName}/getAttr`]('model')) {
      this.$store.dispatch(`${this.modelName}/create`)
    }
  }
}
</script>
